<template>
    <div class="side-bar">
        <router-link tag="h3" to="/member/index">
            <i class="icon icon-member"></i>
            <span>皇家游享荟</span>
        </router-link>
        <ul>
            <li>
                <a @click="onRecommendClick">
                    <i class="icon icon-recommend"></i>
                    <span>推荐有礼</span>
                </a>
            </li>
            <li>
                <router-link tag="a" to="/member/shop/index" :class="activeLink">
                    <i class="icon icon-shop"></i>
                    <span>积分商城</span>
                </router-link>
            </li>
            <li>
                <router-link tag="a" to="/member/shop/gift">
                    <i class="icon icon-gift"></i>
                    <span>我的礼品</span>
                </router-link>
            </li>
            <li>
                <router-link tag="a" to="/member/welfare">
                    <i class="icon icon-welfare"></i>
                    <span>我的福利</span>
                </router-link>
            </li>
            <li>
                <a href="/Rccl.UserCenter/CustomerInfo/Info"><i class="icon icon-personal"></i><span>个人中心</span></a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'SideBar',
        data () {
            return {
                activeLink: ''
            }
        },
        watch: {
            '$route' () {
                if(this.$route.path.indexOf('/shop/index') > -1) {
                    this.activeLink = 'active'
                } else {
                    this.activeLink = ''
                }
            }
        },
        mounted() {
            if(this.$route.path.indexOf('/shop/index') > -1) {
                this.activeLink = 'active'
            } else {
                this.activeLink = ''
            }
        },
        methods: {
            onRecommendClick () {
                this.$store.commit('showRecommendLayer', true)
            }
        }
    }
</script>

<style lang="less" scoped>
    .side-bar{
        width: 230px;
        height: 794px;
        padding-top: 25px;
        background: url("../../../assets/images/side_bar_bg.jpg") no-repeat;
        .icon{
            display: inline-block;
            vertical-align: middle;
            width: 24px;
            height: 24px;
            margin-right: 3px;
            &.icon-member{
                background: url("../../../assets/images/side_bar_tb_home.png") no-repeat center center;
            }
            &.icon-shop{
                background: url("../../../assets/images/side_bar_tb_shop.png") no-repeat center center;
            }
            &.icon-welfare{
                background: url("../../../assets/images/side_bar_tb_welfare.png") no-repeat center center;
            }
            &.icon-personal{
                background: url("../../../assets/images/side_bar_tb_personal.png") no-repeat center center;
            }
            &.icon-recommend{
                background: url("https://resource.rcclchina.com.cn/memberCenter/pc/usercenter-recommand.png") no-repeat center center;
            }
            &.icon-gift{
                background: url("https://resource.rcclchina.com.cn/memberCenter/pc/usercenter-gift.png") no-repeat center center;
            }
        }
        h3{
            display: block;
            padding-left: 36px;
            font-size: 20px;
            line-height: 40px;
            color: #fff;
            cursor: pointer;
            span{
                display: inline-block;
                vertical-align: middle;
            }
            &.active{
                color: #fbc500;
                .icon-member{
                    background: url("../../../assets/images/side_bar_tb_home_active.png") no-repeat center center;
                }
            }
        }
        ul{
            padding-top: 10px;
            li{
                line-height: 49px;
                a{
                    display: block;
                    padding-left: 36px;
                    color: #fff;
                    cursor: pointer;
                    span{
                        display: inline-block;
                        vertical-align: middle;
                    }
                    &.active, &:hover{
                        background-color: #075a9b;
                        color: #fbc500;
                        .icon-shop{
                            background: url("../../../assets/images/side_bar_tb_shop_active.png") no-repeat center center;
                        }
                        .icon-welfare{
                            background: url("../../../assets/images/side_bar_tb_welfare_active.png") no-repeat center center;
                        }
                        .icon-personal{
                            background: url("../../../assets/images/side_bar_tb_personal_active.png") no-repeat center center;
                        }
                        .icon-recommend{
                            background: url("https://resource.rcclchina.com.cn/memberCenter/pc/usercenter-recommand-select.png") no-repeat center center;
                        }
                        .icon-gift{
                            background: url("https://resource.rcclchina.com.cn/memberCenter/pc/usercenter-gift-select.png") no-repeat center center;
                        }
                    }
                }
            }
        }
    }
</style>
